import { type Actions, ActionType } from './buildings-accesses.actions';
import { buildingAccessAdapter, initialState, type State } from './buildings-accesses.state';

export function buildingsAccessesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_BUILDINGS_ACCESSES: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_BUILDINGS_ACCESSES_SUCCEEDED: {
            return buildingAccessAdapter.setAll(action.payload.buildingsAccesses, {
                ...state,
                isPending: false,
                isLoaded: true
            });
        }

        case ActionType.FETCH_BUILDINGS_ACCESSES_FAILED: {
            return {
                ...state,
                isPending: false
            };
        }

        case ActionType.CREATE_BUILDING_ACCESS: {
            return buildingAccessAdapter.addOne(action.payload.buildingAccess, state);
        }

        case ActionType.CREATE_BUILDINGS_ACCESSES: {
            return buildingAccessAdapter.addMany(action.payload.buildingsAccesses, state);
        }

        case ActionType.RESET: {
            return {
                ...initialState
            };
        }

        default:
            return state;
    }
}
